import { PetRegistry, PetType, VaccinationRecord } from '../models/pet-registry.model';

export const MOCK_PET_REGISTRY: PetRegistry[] = [
  {
    id: 1,
    residentId: 1,
    petName: 'Buddy',
    petNameKey: 'pets.buddy',
    petType: PetType.DOG,
    breed: 'Golden Retriever',
    breedKey: 'pets.golden-retriever',
    age: 3,
    weight: 65,
    color: 'Golden',
    colorKey: 'pets.golden-color',
    microchipId: '982000123456789',
    vaccinationRecords: [
      {
        id: 1,
        petId: 1,
        vaccineName: 'Rabies',
        administeredDate: new Date('2023-12-15T00:00:00Z'),
        expiryDate: new Date('2024-12-15T00:00:00Z'),
        vetName: 'Dr. Sarah Johnson',
        vetClinic: 'Sunset Animal Hospital',
        batchNumber: 'RAB-2023-001',
        nextDueDate: new Date('2024-12-15T00:00:00Z'),
      },
      {
        id: 2,
        petId: 1,
        vaccineName: 'DHPP',
        administeredDate: new Date('2023-12-15T00:00:00Z'),
        expiryDate: new Date('2024-12-15T00:00:00Z'),
        vetName: 'Dr. Sarah Johnson',
        vetClinic: 'Sunset Animal Hospital',
        batchNumber: 'DHPP-2023-002',
        nextDueDate: new Date('2024-12-15T00:00:00Z'),
      },
    ],
    registrationDate: new Date('2023-06-15T00:00:00Z'),
    expiryDate: new Date('2024-06-15T00:00:00Z'),
    isActive: true,
    specialNeeds: 'Requires daily medication for hip dysplasia',
    specialNeedsKey: 'pets.buddy-special-needs',
    emergencyContact: 'Jane Smith - +1-555-0102',
    vetName: 'Dr. Sarah Johnson',
    vetNameKey: 'pets.dr-sarah-johnson',
    vetContact: '+1-555-2000',
    photos: ['https://example.com/pets/buddy-1.jpg', 'https://example.com/pets/buddy-2.jpg'],
    notes: 'Friendly and well-behaved dog. Gets along well with children.',
    notesKey: 'pets.buddy-notes',
  },
  {
    id: 2,
    residentId: 2,
    petName: 'Whiskers',
    petNameKey: 'pets.whiskers',
    petType: PetType.CAT,
    breed: 'Maine Coon',
    breedKey: 'pets.maine-coon',
    age: 5,
    weight: 12,
    color: 'Orange Tabby',
    colorKey: 'pets.orange-tabby',
    microchipId: '982000987654321',
    vaccinationRecords: [
      {
        id: 3,
        petId: 2,
        vaccineName: 'Rabies',
        administeredDate: new Date('2023-11-20T00:00:00Z'),
        expiryDate: new Date('2024-11-20T00:00:00Z'),
        vetName: 'Dr. Michael Chen',
        vetClinic: 'City Veterinary Clinic',
        batchNumber: 'RAB-2023-003',
        nextDueDate: new Date('2024-11-20T00:00:00Z'),
      },
      {
        id: 4,
        petId: 2,
        vaccineName: 'FVRCP',
        administeredDate: new Date('2023-11-20T00:00:00Z'),
        expiryDate: new Date('2024-11-20T00:00:00Z'),
        vetName: 'Dr. Michael Chen',
        vetClinic: 'City Veterinary Clinic',
        batchNumber: 'FVRCP-2023-004',
        nextDueDate: new Date('2024-11-20T00:00:00Z'),
      },
    ],
    registrationDate: new Date('2023-08-20T00:00:00Z'),
    expiryDate: new Date('2024-08-20T00:00:00Z'),
    isActive: true,
    specialNeeds: 'None',
    specialNeedsKey: 'pets.whiskers-special-needs',
    emergencyContact: 'Carlos Garcia - +1-555-0202',
    vetName: 'Dr. Michael Chen',
    vetNameKey: 'pets.dr-michael-chen',
    vetContact: '+1-555-2001',
    photos: ['https://example.com/pets/whiskers-1.jpg'],
    notes: 'Indoor cat, very social and playful.',
    notesKey: 'pets.whiskers-notes',
  },
  {
    id: 3,
    residentId: 4,
    petName: 'Nemo',
    petNameKey: 'pets.nemo',
    petType: PetType.FISH,
    breed: 'Goldfish',
    breedKey: 'pets.goldfish',
    age: 2,
    weight: 0.5,
    color: 'Orange and White',
    colorKey: 'pets.orange-white-color',
    microchipId: undefined,
    vaccinationRecords: [],
    registrationDate: new Date('2023-11-05T00:00:00Z'),
    expiryDate: new Date('2024-11-05T00:00:00Z'),
    isActive: true,
    specialNeeds: 'Requires specific water temperature and pH levels',
    specialNeedsKey: 'pets.nemo-special-needs',
    emergencyContact: 'Michael Brown - +1-555-0402',
    vetName: 'Dr. Lisa Park',
    vetNameKey: 'pets.dr-lisa-park',
    vetContact: '+1-555-2002',
    photos: ['https://example.com/pets/nemo-1.jpg'],
    notes: 'Tropical fish, requires heated aquarium.',
    notesKey: 'pets.nemo-notes',
  },
  {
    id: 4,
    residentId: 5,
    petName: 'Coco',
    petNameKey: 'pets.coco',
    petType: PetType.BIRD,
    breed: 'Cockatiel',
    breedKey: 'pets.cockatiel',
    age: 4,
    weight: 0.3,
    color: 'Yellow and Gray',
    colorKey: 'pets.yellow-gray-color',
    microchipId: undefined,
    vaccinationRecords: [
      {
        id: 5,
        petId: 4,
        vaccineName: 'Avian Polyomavirus',
        administeredDate: new Date('2023-10-10T00:00:00Z'),
        expiryDate: new Date('2024-10-10T00:00:00Z'),
        vetName: 'Dr. Amanda Foster',
        vetClinic: 'Avian Veterinary Services',
        batchNumber: 'APV-2023-005',
        nextDueDate: new Date('2024-10-10T00:00:00Z'),
      },
    ],
    registrationDate: new Date('2023-09-12T00:00:00Z'),
    expiryDate: new Date('2024-09-12T00:00:00Z'),
    isActive: true,
    specialNeeds: 'Requires daily interaction and mental stimulation',
    specialNeedsKey: 'pets.coco-special-needs',
    emergencyContact: 'Patricia Wilson - +1-555-0502',
    vetName: 'Dr. Amanda Foster',
    vetNameKey: 'pets.dr-amanda-foster',
    vetContact: '+1-555-2003',
    photos: ['https://example.com/pets/coco-1.jpg', 'https://example.com/pets/coco-2.jpg'],
    notes: 'Very talkative bird, can mimic sounds and words.',
    notesKey: 'pets.coco-notes',
  },
];
